import { Cookie } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useCookieConsent } from "@/stores/useCookieConsent";

export function CookieSettingsButton() {
  const { t } = useTranslation();
  const { showBanner, hasConsented, openPreferences } = useCookieConsent();

  // バナー表示中、または未同意時は非表示
  if (showBanner || !hasConsented) return null;

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={openPreferences}
      className="fixed bottom-4 right-4 h-12 w-12 rounded-full shadow-lg z-40 hover:scale-110 transition-transform"
      aria-label={t("cookieConsent.settings.buttonAria")}
    >
      <Cookie className="h-5 w-5" />
    </Button>
  );
}
